// Code Enforcement Image Upload Module
const CodeEnforcementImageUpload = (function() {
    // Private state - scoped to this module only
    let imageState = { capture: false, lat: null, long: null };

    function formatTimestamp(date = new Date()) {
        let time = date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        }).toLowerCase();

        let fullDate = date.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric"
        });

        let weekday = date.toLocaleDateString("en-US", {
            weekday: "long"
        });

        return `${time} | ${fullDate} | ${weekday}`;
    }

    async function getLocation() {
        try {
            const data = await $.ajax({
                url: "/health_inspections/get_location",
                data: { lat: imageState.lat, long: imageState.long },
                method: "GET",
                dataType: "json"
            });

            if (data) {
                return { success: true, location: data.location || 'Location not found'};
            } else {
                return { success: false, error: "Invalid response format" };
            }
        } catch (e) {
            return { success: false, error: "Failed to get location" };
        }
    }

    async function extractImageInfo(file) {
        const formData = new FormData();
        formData.append('file', file);
        try {
            const data = await $.ajax({
                url: '/health_inspections/extract_image_info',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                }
            });

            if (data && data.metadata) {
                return { success: true, ...data.metadata };
            } else {
                return { success: false, date_time_original: null, date_time_original_iso: null, location: null };
            }
        } catch (e) {
            return { success: false, date_time_original: null, date_time_original_iso: null, location: null };
        }
    }

    // Get metadata (timestamp and location) for the image
    async function getImageMetadata(imageInfo) {
        let timestamp, timestampDisplay, location;

        if (imageInfo.date_time_original_iso) {
            timestamp = imageInfo.date_time_original_iso;
            timestampDisplay = imageInfo.date_time_original || null;
            location = imageInfo.location || null;
        } else if (imageState.capture === false) {
            timestamp = null;
            timestampDisplay = null;
            location = imageInfo.location || null;
        } else {
            // Captured image - use current time and device location
            const now = new Date();
            timestamp = now.toISOString();
            timestampDisplay = formatTimestamp(now);

            const locationData = await getLocation();
            location = locationData.success ? locationData.location : null;
        }

        return {
            timestamp: timestamp,
            timestampDisplay: timestampDisplay,
            location: location
        };
    }

    function requestLocation() {
        if (!("geolocation" in navigator)) {
            console.error("Geolocation is not supported by your browser.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                imageState.lat = position.coords.latitude;
                imageState.long = position.coords.longitude;

                $('#ceLocationAccessModalHeader').text('Location Access Granted');
                $('#ceLocationAccessModalBody').html('<p>Location access has been granted. Location will be tagged for the captured images only.</p>');
            },
            (error) => {
                console.error("Error getting location:", error.message);
                $('#ceLocationAccessModalHeader').text('Location Access Denied');
                $('#ceLocationAccessModalBody').html('<p>Location access is required. Please enable it in your browser or device settings.</p><p>Without location access there will be no location information on the violation images.</p><p>However you can continue taking pictures.</p><a href="https://support.google.com/chrome/answer/142065?hl=en&co=GENIE.Platform%3DAndroid&oco=0" target=_blank style="text-decoration: none">How to enable location?</a>');
                $('#ceLocationAccessModal').modal('show');
            }
        );
    }

    // Public API
    return {
        getState: function() { return imageState; },
        setState: function(key, value) { imageState[key] = value; },
        requestLocation: requestLocation,
        extractImageInfo: extractImageInfo,
        getImageMetadata: getImageMetadata
    };
})();

function initializeImageUploadHandlers(violationForm) {
    const ceImagesSection = $(violationForm).find('.ceImagesSection');
    const uploadBtn = $(violationForm).find('.uploadCeImageBtn');
    const captureBtn = $(violationForm).find('.ce-capture-image-btn');
    const fileField = $(violationForm).find('.uploadCeImageField');
    const addImageBtn = $(violationForm).find('.addImageRowBtn');

    function createImageRow(file, metadata = {}) {
        var mouseEvt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        addImageBtn[0].dispatchEvent(mouseEvt);

        let targetEle = $(ceImagesSection).find('.file-field').last();
        let nestedField = $(targetEle).closest('.nested-fields');
        let imageContainer = $(targetEle).closest('.image-container');
        let imageCard = $(targetEle).closest('.ce-image-card');

        let newImage = document.createElement('img');
        newImage.src = URL.createObjectURL(file);
        newImage.className = 'image-section';
        imageContainer.find('.upload-btn').remove();
        imageContainer.prepend(newImage);

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);

        targetEle[0].files = dataTransfer.files;

        // Populate hidden fields with metadata
        if (metadata.timestamp) {
            nestedField.find('.uploaded-at-field').val(metadata.timestamp);
        }
        if (metadata.location) {
            nestedField.find('.location-field').val(metadata.location);
        }

        // Display metadata below the image
        let metadataContainer = imageCard.find('.image-metadata');
        metadataContainer.empty();

        if (metadata.timestampDisplay) {
            metadataContainer.append(`<div class="timestamp-display">${metadata.timestampDisplay}</div>`);
        }
        if (metadata.location) {
            metadataContainer.append(`<div class="location-display">${metadata.location}</div>`);
        }

        return targetEle;
    }

    // reattach events
    uploadBtn.off('click');
    captureBtn.off('click');
    fileField.off('change');

    uploadBtn.on('click', function() {
        CodeEnforcementImageUpload.setState('capture', false);
        fileField.removeAttr('capture');
        fileField.click();
    });

    captureBtn.on('click', function() {
        CodeEnforcementImageUpload.setState('capture', true);
        fileField.attr('capture', 'environment');

        if ('permissions' in navigator) {
            navigator.permissions.query({ name: 'geolocation' }).then(result => {
                if (result.state === 'granted') {
                    CodeEnforcementImageUpload.requestLocation();
                    fileField.click();
                } else if (result.state === 'prompt') {
                    CodeEnforcementImageUpload.requestLocation();
                    $('#ceLocationAccessModalHeader').text('Location Access Required');
                    $('#ceLocationAccessModalBody').html('<p>This app would like to access your location to:</p><ul><li>Add location information to your photos</li><li>Create a timestamp with coordinates</li><li>Provide better photo organization</li></ul><p>Your privacy matters: Location data will only be used for photo tagging and will not be shared with third parties.</p>');
                    $('#ceLocationAccessModal').modal('show');
                    $('#ceLocationAccessModal').data('fileField', fileField);
                } else if (result.state === 'denied') {
                    $('#ceLocationAccessModalHeader').text('Location Access Denied');
                    $('#ceLocationAccessModalBody').html('<p>Location access is required. Please enable it in your browser or device settings.</p><p>Without location access there will be no location information on the violation images.</p><p>However you can continue taking pictures.</p><a href="https://support.google.com/chrome/answer/142065?hl=en&co=GENIE.Platform%3DAndroid&oco=0" target=_blank style="text-decoration: none">How to enable location?</a>');
                    $('#ceLocationAccessModal').modal('show');
                    $('#ceLocationAccessModal').data('fileField', fileField);
                }
            });
        } else {
            CodeEnforcementImageUpload.requestLocation();
            fileField.click();
        }
    });

    fileField.on('change', async function(evt) {
        const files = evt.target.files;
        if (files && files.length > 0) {
            // Show loading indicator
            const loadingIndicator = document.createElement('div');
            loadingIndicator.className = 'text-center mt-3 ce-loading-indicator';
            loadingIndicator.innerHTML = '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Processing images...</span></div>';
            ceImagesSection.append(loadingIndicator);

            try {
                for (const file of Array.from(files)) {
                    const imageInfo = await CodeEnforcementImageUpload.extractImageInfo(file);
                    const metadata = await CodeEnforcementImageUpload.getImageMetadata(imageInfo);

                    let processedFile = file;
                    if (file.type.startsWith('image/') && window.compressImage) {
                        processedFile = await window.compressImage(file);
                    }

                    createImageRow(processedFile, metadata);
                }
            } catch (error) {
                console.error('Error processing images:', error);
                if (window.rollbar) {
                    window.rollbar.error('Error processing CE images:', error);
                }

                // Fallback to original upload without compression/metadata
                Array.from(files).forEach(function (file) {
                    createImageRow(file, {});
                });
            } finally {
                loadingIndicator.remove();
                CodeEnforcementImageUpload.setState('capture', false);
            }
        }
    });
}

function initializeSelect2(violationForm) {
    $(violationForm).find('.search-master-violation').select2({
        placeholder: "Select Violation Category",
        focus: true,
        allowClear: true,
    });

    $(violationForm).find('.search-violation-type').select2({
        placeholder: "Select Violation Type",
        focus: true,
        allowClear: true,
    });
}

function initializeDatePickers(violationForm) {
    $(violationForm).find('.date-picker').each(function() {
        if (!this._flatpickr) {
            flatpickr(this, {
                altInput: true,
                altFormat: "m/d/Y",
                dateFormat: "Y-m-d",
                allowInput: true
            });
        }
    });
}

function initializeViolationForm(violationForm) {
    initializeSelect2(violationForm);
    initializeDatePickers(violationForm);
    initializeImageUploadHandlers(violationForm);
}

document.addEventListener('turbolinks:load', function () {
    if ($('.code_enforcements.new, .code_enforcements.create, .code_enforcements.edit, .code_enforcements.update, .ce_case_violations.index').length === 0) {
        return false
    }

    if($('.code_enforcements.new').length > 0) {
        // Is the address same as Owner 1? should be hidden for the first ce_owner_detail
        if($('.same-owner-address-checkbox').length > 0) {
            $('.same-owner-address-checkbox')[0].parentElement.classList.add('d-none');
        }

        // Relation to owner should be hidden for the first ce_owner_detail
        if($('.relation-to-owner').length > 0) {
            $('.relation-to-owner')[0].classList.add('d-none');
        }
    }

    $('#violation-cases > .nested-fields').each(function() {
        initializeViolationForm(this);
    });

    $(document).on('change', '#code_enforcement_report_type', function () {
        let reportType = $(this).val()
        let otherReportTypeField = $('#otherReportTypeField')

        if (reportType && reportType === 'Other') {
            $(otherReportTypeField).removeClass('d-none')
        } else {
            $(otherReportTypeField).addClass('d-none')
            $(otherReportTypeField).find('#code_enforcement_other_report_type').removeClass('requiredField')
        }
    })

    $(document).on('change', '.same-address-checkbox', function () {
        if ($(this).is(':checked')) {
            let targetEle = $(this).closest('.nested-fields');
            // uncheck if owner address is checked
            if(targetEle.find('.same-owner-address-checkbox').is(':checked')) {
                targetEle.find('.same-owner-address-checkbox').prop('checked', false);
            }

            let state = $("#stateField").val()
            let county = $("#countyField").val()
            let city = $("#cityField").val()
            let zipCode = $("#zipCodeField").val()
            let parcel = $("#parcelField").val()
            let suite = $("#suiteField").val()
            let street = $("#streetField").val()
            let block = $("#blockField").val()
            let lot = $("#lotField").val()

            let addressSection = $(this).parents('.record-row').find('.address-section')
            addressSection.find('#stateField').val(state)
            addressSection.find('#countyField').val(county)
            addressSection.find('#cityField').val(city)
            addressSection.find('#zipCodeField').val(zipCode)
            addressSection.find('#parcelField').val(parcel)
            addressSection.find('#suiteField').val(suite)
            addressSection.find('#streetField').val(street)
            addressSection.find('#blockField').val(block)
            addressSection.find('#lotField').val(lot)
        }
    })

    $(document).on('change', '.custom-select-dropdown.address_type, .custom-select-dropdown.relation_to_owner', function () {
        const targetEleCss = this.dataset.targetField;
        if (!targetEleCss) return;

        const ownerForm = $(this).closest('.nested-fields');
        const targetTextField = ownerForm.find(`.${targetEleCss}`);
        if (targetTextField.length === 0) return;

        let parentElement = targetTextField.closest('.row');
        const customInput = targetTextField.find('input.custom');

        if(this.value == 'custom_relation_to_owner' || this.value == 'custom_address_type') {
            parentElement.removeClass('d-none');
            targetTextField.css('visibility', 'visible');
        } else {
            targetTextField.css('visibility', 'hidden');
            customInput.removeClass('requiredField').removeClass('is-invalid').removeClass('error-field');
            customInput.val('');
            targetTextField.find('.error-message').remove();
        }

        const hasVisibleField = parentElement.find('.form-field').filter(function () {
            return $(this).css('display') !== 'none' &&
                   $(this).css('visibility') !== 'hidden';
        }).length > 0;

        if(hasVisibleField) {
            parentElement.removeClass('d-none');
            parentElement.addClass('mb-3');
        } else {
            parentElement.removeClass('mb-3');
            parentElement.addClass('d-none');
        }
    });

    $('#ce_owner_details').on('cocoon:after-insert', function(_, insertedItem) {
        if($('#ce_owner_details').find('.nested-fields').length > 1) {
            insertedItem.find('.same-owner-address').removeClass('d-none');
        }
    });

    $(document).on('change', '.same-owner-address-checkbox', function () {
        const ownerInfoEle = $($('#ce_owner_details').find('.nested-fields')[0])

        if ($(this).is(':checked')) {
            let targetEle = $(this).closest('.nested-fields');

            // uncheck if case address is checked
            if(targetEle.find('.same-address-checkbox').is(':checked')) {
                targetEle.find('.same-address-checkbox').prop('checked', false);
            }

            let state = ownerInfoEle.find('#stateField').val();
            let county = ownerInfoEle.find('#countyField').val();
            let city = ownerInfoEle.find('#cityField').val();
            let zipCode = ownerInfoEle.find('#zipCodeField').val();
            let parcel = ownerInfoEle.find('#parcelField').val();
            let suite = ownerInfoEle.find('#suiteField').val();
            let street = ownerInfoEle.find('#streetField').val();
            let hcad_acc_no = ownerInfoEle.find('.hcad_acc_no').val();
            let block = ownerInfoEle.find('#blockField').val();
            let lot = ownerInfoEle.find('#lotField').val();

            targetEle.find('#stateField').val(state)
            targetEle.find('#countyField').val(county)
            targetEle.find('#cityField').val(city)
            targetEle.find('#zipCodeField').val(zipCode)
            targetEle.find('#parcelField').val(parcel)
            targetEle.find('#suiteField').val(suite)
            targetEle.find('#streetField').val(street)
            targetEle.find('.hcad_acc_no').val(hcad_acc_no)
            targetEle.find('#blockField').val(block)
            targetEle.find('#lotField').val(lot)
        }
    });

    $('#violation-cases').on('cocoon:after-insert', function(_, insertedItem) {
        let uniqueId = 'new-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        let violationId = 'violation-' + uniqueId;
        let headingId = 'heading-' + violationId;
        let collapseId = 'collapse-' + violationId;

        let accordionHeader = $(insertedItem).find('.accordion-header');
        let accordionButton = $(insertedItem).find('.accordion-button');
        let accordionCollapse = $(insertedItem).find('.accordion-collapse');

        if (accordionHeader.length) {
            accordionHeader.attr('id', headingId);
        }

        if (accordionButton.length) {
            accordionButton.attr('data-bs-target', '#' + collapseId);
            accordionButton.attr('aria-controls', collapseId);
            accordionButton.removeClass('collapsed');
            accordionButton.attr('aria-expanded', 'true');
        }

        if (accordionCollapse.length) {
            accordionCollapse.attr('id', collapseId);
            accordionCollapse.attr('aria-labelledby', headingId);
            accordionCollapse.addClass('show');
        }

        initializeViolationForm(insertedItem);
    });

    // Location access modal handlers
    $('#ce-location-denied-warning').on('click', function() {
        $('#ce-location-permission-denied-warning').addClass('d-none');
    });

    $('#ce-go-to-capture').on('click', function() {
        $('#ceLocationAccessModal').modal('hide');
        let $fileField = $('#ceLocationAccessModal').data('fileField');
        if ($fileField) {
            $fileField.click();
        }
    });

    $(document).on('change', '.custom-select-dropdown.violation-kind, .custom-select-dropdown.mode-of-complaint, .custom-select-dropdown.mode-of-notification', function () {
        const targetEleCss = this.dataset.targetField;

        if (!targetEleCss) return;

        const violationForm = $(this).closest('.violation-form');
        const targetTextField = violationForm.find(`.${targetEleCss}`);

        if (targetTextField.length === 0) return;

        let parentElement = targetTextField.closest('.row');
        const customInput = targetTextField.find('input.custom');

        if(this.value === 'custom_violation' || this.value === 'custom_mode_of_complaint' || this.value === 'custom_mode_of_notification') {
            parentElement.removeClass('d-none');
            targetTextField.css('visibility', 'visible');
        } else {
            targetTextField.css('visibility', 'hidden');
            customInput.removeClass('requiredField').removeClass('is-invalid').removeClass('error-field');
            customInput.val('');
            targetTextField.find('.error-message').remove();
        }

        const hasVisibleField = parentElement.find('.form-field').filter(function () {
            return $(this).css('display') !== 'none' &&
                   $(this).css('visibility') !== 'hidden';
          }).length > 0;

        if(hasVisibleField) {
            parentElement.removeClass('d-none');
            parentElement.addClass('mb-4');
        } else {
            parentElement.removeClass('mb-4');
            parentElement.addClass('d-none');
        }
	});
});
